<h1 id="title" class="title">Đăng ký tài khoản</h1>

<nb-alert
  *ngIf="showMessages.error && errors?.length && !submitted"
  outline="danger"
  role="alert"
>
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert
  *ngIf="showMessages.success && messages?.length && !submitted"
  outline="success"
  role="alert"
>
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">
      {{ message }}
    </li>
  </ul>
</nb-alert>

<div [formGroup]="registerForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-name">Tên:</label>
    <input
      nbInput
      autofocus
      fullWidth
      fieldSize="large"
      id="input-name"
      formControlName="fullName"
      [status]="login.dirty ? (login.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="login.invalid && login.touched ? true : null"
      placeholder="Tên hiển thị"
    />
    <ngx-validation-message
      label="Tên"
      [showMinLength]="login?.hasError('minlength') && login.touched"
      [showMaxLength]="login?.hasError('maxlength') && login.touched"
      [minLength]="minLoginLength"
      [maxLength]="maxLoginLength"
      [showRequired]="login?.errors?.required && login.touched"
    >
    </ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-email">Email:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-email"
      formControlName="email"
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="email.invalid && email.touched ? true : null"
      placeholder="Email address"
    />
    <ngx-validation-message
      label="Email address"
      [showPattern]="email?.hasError('pattern') && email.touched"
      [showRequired]="email?.errors?.required && email.touched"
    ></ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-password">Mật khẩu:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-password"
      formControlName="password"
      type="password"
      [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : ''"
      placeholder="Password"
    />
    <ngx-validation-message
      label="Password"
      [showMinLength]="password?.hasError('minlength') && password.touched"
      [showMaxLength]="password?.hasError('maxlength') && password.touched"
      [showRequired]="password?.errors?.required && password.touched"
      [minLength]="minLength"
      [maxLength]="maxLength"
    ></ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-re-password">Xác nhận mật khẩu:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-re-password"
      formControlName="confirmPassword"
      type="password"
      [status]="
        confirmPassword.dirty
          ? confirmPassword.invalid || password.value != confirmPassword.value
            ? 'danger'
            : 'success'
          : ''
      "
      placeholder="Password"
    />
    <ngx-validation-message
      label="Confirm Password"
      [showMinLength]="
        confirmPassword?.hasError('minlength') && confirmPassword.touched
      "
      [showMaxLength]="
        confirmPassword?.hasError('maxlength') && confirmPassword.touched
      "
      [showRequired]="
        confirmPassword?.errors?.required && confirmPassword.touched
      "
      [minLength]="minLength"
      [maxLength]="maxLength"
    ></ngx-validation-message>
    <p
      class="caption status-danger"
      *ngIf="password.value != confirmPassword.value"
    >
      Xác nhận mật không trùng với mật khẩu!
    </p>
  </div>

  <div
    class="form-control-group accept-group"
    *ngIf="getConfigValue('forms.register.terms')"
  >
    <nb-checkbox
      formControlName="terms"
      [required]="getConfigValue('forms.register.terms')"
    >
      Đồng ý
      <a href="https://www.kasoft.vn/dieu-khoan-su-dung" target="_blank"
        ><strong>điều khoản dịch vụ</strong></a
      >
    </nb-checkbox>
  </div>

  <button
    nbButton
    fullWidth
    status="primary"
    size="large"
    [disabled]="
      submitted ||
      !registerForm.valid ||
      !terms?.value ||
      password.value != confirmPassword.value
    "
    [class.btn-pulse]="submitted"
    (click)="register()"
  >
    Đăng ký
  </button>
</div>

<section
  *ngIf="socialLinks && socialLinks.length > 0"
  class="links"
  aria-label="Social sign in"
>
  or enter with:
  <div class="socials">
    <ng-container *ngFor="let socialLink of socialLinks">
      <a
        *ngIf="socialLink.link"
        [routerLink]="socialLink.link"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
      <a
        *ngIf="socialLink.url"
        [attr.href]="socialLink.url"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
    </ng-container>
  </div>
</section>

<section class="another-action" aria-label="Sign in">
  Đã có tài khoản? <a class="text-link" routerLink="../login">Đăng nhập</a>
</section>
